// Nigerian-context formatters
export const formatNaira = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "₦0";
  const v = Math.round(Number(n));
  return "₦" + v.toLocaleString("en-NG");
};

const pad = (n) => String(n).padStart(2, "0");

export const toWAT = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  // WAT = UTC+1
  return new Date(d.getTime() + 60 * 60 * 1000);
};

export const formatDateDDMMYYYY = (iso) => {
  if (!iso) return "";
  const d = toWAT(iso);
  return `${pad(d.getUTCDate())}/${pad(d.getUTCMonth() + 1)}/${d.getUTCFullYear()}`;
};

export const formatTimeWAT = (iso) => {
  if (!iso) return "";
  const d = toWAT(iso);
  return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} WAT`;
};

export const formatDateTimeWAT = (iso) => {
  if (!iso) return "";
  return `${formatDateDDMMYYYY(iso)} ${formatTimeWAT(iso)}`;
};

export const relativeTime = (iso) => {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};
